import { render, staticRenderFns } from "./classOrder.vue?vue&type=template&id=06e50972&scoped=true"
import script from "./classOrder.vue?vue&type=script&lang=js"
export * from "./classOrder.vue?vue&type=script&lang=js"
import style0 from "./classOrder.vue?vue&type=style&index=0&id=06e50972&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e50972",
  null
  
)

export default component.exports